<template>
  <div class="container editResume">
    <h2>编辑简历</h2>
    <van-form ref="form" v-model="form" :scroll-to-error="true">
      <van-divider>基本信息</van-divider>
      <van-field
        v-model="form.organLabel"
        label="意向门店"
        readonly
        disabled
        :rules="formRules.organ"
      />
      <van-popup v-model:show="showOrganList" position="bottom" teleport="body">
        <van-picker
          :columns="organList"
          :columns-field-names="{ text: 'LNAME', value: 'ID' }"
          @confirm="onOrganListConfirm"
          @cancel="showOrganList = false"
        />
      </van-popup>
      <van-field
        v-model="form.departLabel"
        label="意向部门"
        disabled
        readonly
        :rules="formRules.depart"
      />
      <van-popup v-model:show="showDepartList" position="bottom" teleport="body">
        <van-picker
          :columns="departList"
          :columns-field-names="{ text: 'LNAME', value: 'ID' }"
          @confirm="onDepartListConfirm"
          @cancel="showDepartList = false"
        />
      </van-popup>
      <van-field
        v-model="form.postLabel"
        label="意向岗位"
        readonly
        disabled
        :rules="formRules.post"
      />
      <van-popup v-model:show="showPostList" position="bottom" teleport="body">
        <van-picker
          :columns="postList"
          :columns-field-names="{ text: 'PNAME', value: 'ID' }"
          @confirm="onPostListConfirm"
          @cancel="showPostList = false"
        />
      </van-popup>
      <van-field
        v-model="form.recruitSourceLabel"
        label="招聘来源"
        name="recruitSource"
        :rules="formRules.recruitSource"
        disabled
        placeholder="请选择在何处得知招聘信息"
      />
      <van-popup v-model:show="showRecruitSourceList" position="bottom">
        <van-picker
          :columns="recruitSourceList"
          :columns-field-names="{ text: 'DTEXT', value: 'DVALUE' }"
          @confirm="onRecruitSourceConfirm"
          @cancel="showRecruitSourceList = false"
        />
      </van-popup>
      <van-field
        v-model="form.name"
        label="姓名"
        name="name"
        :rules="formRules.name"
        disabled
      />
      <van-field label="性别" disabled>
        <template #input>
          <van-radio-group
            v-model="form.gender"
            disabled
            direction="horizontal"
            :rules="formRules.gender"
            checked-color="#da0b66"
            icon-size="16"
          >
            <van-radio name="1">男</van-radio>
            <van-radio name="2">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-model="form.sfid"
        label="身份证"
        name="sfid"
        :formatter="sfidFormatter"
        disabled
      />
      <van-field
        v-model="form.sfiddate"
        label="身份证有效期"
        name="sfiddate"
        placeholder="请填写身份证有效期限的截止日期"
        :rules="formRules.sfiddate"
        @click="showSfidDate = true"
      />
      <van-popup v-model:show="showSfidDate" position="bottom" teleport="body">
        <van-datetime-picker
          type="date"
          :min-date="new Date()"
          :max-date="new Date(2099, 12, 31)"
          @confirm="onSfidDateConfirm"
          @cancel="showSfidDate = false"
        />
      </van-popup>
      <van-field label="婚姻状况" disabled>
        <template #input>
          <van-radio-group
            v-model="form.married"
            direction="horizontal"
            :rules="formRules.married"
            checked-color="#da0b66"
            icon-size="16"
          >
            <van-radio name="1">未婚</van-radio>
            <van-radio name="2">已婚</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field label="政治面貌" name="political" disabled>
        <template #input>
          <van-radio-group
            v-model="form.political"
            disabled
            direction="horizontal"
            :rules="formRules.political"
            checked-color="#da0b66"
            icon-size="16"
          >
            <van-radio name="1">群众</van-radio>
            <van-radio name="3">团员</van-radio>
            <van-radio name="2">党员</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-model="form.nationLabel"
        label="民族"
        readonly
        disabled
        name="nation"
        :rules="formRules.nationLabel"
      />
      <van-popup v-model:show="showNationList" position="bottom" teleport="body">
        <van-picker
          :columns="nationList"
          :columns-field-names="{ text: 'DTEXT', value: 'DVALUE' }"
          @confirm="onNationConfirm"
          @cancel="showNationList = false"
        />
      </van-popup>
      <van-field
        v-model="form.reghouseLabel"
        label="户口所在地"
        name="reghouse"
        disabled
        readonly
        :rules="formRules.reghouse"
      />
      <van-popup v-model:show="showReghouseList" position="bottom" teleport="body">
        <van-area
          :area-list="areaList"
          @confirm="onReghouseConfirm"
          @cancel="showReghouseList = false"
        />
      </van-popup>
      <van-field
        v-model="form.sfidaddr"
        label="身份证住址"
        name="homeaddr"
        :rules="formRules.sfidaddr"
      />
      <van-field
        v-model="form.phone"
        label="联系方式"
        type="tel"
        name="phone"
        disabled
      />
      <van-field
        v-model="form.interest"
        label="兴趣爱好"
        name="interest"
        :rules="formRules.interest"
      />
      <van-field v-model="form.height" label="身高(cm)" name="height" maxlength="3" type="number" placeholder="请填写身高 如:175" :rules="formRules.height" disabled />
      <van-field v-model="form.weight" label="体重(kg)" name="weight" maxlength="3" type="number" placeholder="请填写体重 如:70" :rules="formRules.weight" disabled />
      <van-field v-model="form.email" label="电子邮件" name="email" placeholder="请填写电子邮箱地址" :rules="form.jobtype === '2' ? [] : formRules.email" disabled />
      <van-field v-show="form.jobtype !== '1'" label-width="7em" label="原单位劳动关系" name="workstatus">
        <template #input>
          <van-radio-group
            v-model="form.workstatus"
            direction="horizontal"
            :rules="form.jobtype !== '1' ? [] : formRules.workstatus"
            checked-color="#da0b66"
            disabled
            icon-size="16"
          >
            <van-radio name="1">已解除</van-radio>
            <van-radio name="2">未解除</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-divider>教育经历</van-divider>
      <van-field
        v-model="form.educationLabel"
        label="最高学历"
        disabled
        readonly
        name="education"
        :rules="formRules.education"
      />
      <van-popup v-model:show="showEducationList" position="bottom" teleport="body">
        <van-picker
          :columns="educationList"
          :columns-field-names="{ text: 'DTEXT', value: 'DVALUE' }"
          @confirm="onEducationConfirm"
          @cancel="showEducationList = false"
        />
      </van-popup>
      <van-field
        v-model="form.educschool"
        label="毕业院校"
        name="educschool"
        disabled
        :rules="formRules.educschool"
      />
      <van-field label="学习方式" name="eductype" disabled>
        <template #input>
          <van-radio-group
            v-model="form.eductype"
            direction="horizontal"
            :rules="formRules.eductype"
            checked-color="#da0b66"
            disabled
            icon-size="16"
          >
            <van-radio name="1">全日制统招</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-model="form.educstart"
        label="开始时间"
        readonly
        disabled
        name="educstart"
        :rules="formRules.educstart"
      />
      <van-popup v-model:show="showEducStart" position="bottom" teleport="body">
        <van-datetime-picker
          type="year-month"
          :min-date="new Date(1990, 1, 1)"
          @confirm="onEducStartConfirm"
          @cancel="showEducStart = false"
        />
      </van-popup>
      <van-field
        v-model="form.educend"
        label="结束时间"
        readonly
        disabled
        name="educend"
        :rules="formRules.educend"
      />
      <van-popup v-model:show="showEducEnd" position="bottom" teleport="body">
        <van-datetime-picker
          type="year-month"
          :min-date="new Date(1990, 1, 1)"
          @confirm="onEducEndConfirm"
          @cancel="showEducEnd = false"
        />
      </van-popup>
      <van-field
        v-model="form.spectypeLabel"
        label="专业分类"
        readonly
        disabled
        name="spectype"
        :rules="formRules.spectype"
        @click="showSpecTypeList = true"
      />
      <van-popup v-model:show="showSpecTypeList" position="bottom" teleport="body">
        <van-picker
          :columns="specTypeList"
          :columns-field-names="{ text: 'DTEXT', value: 'DVALUE' }"
          @confirm="onSpecTypeConfirm"
          @cancel="showSpecTypeList = false"
        />
      </van-popup>
      <van-field
        v-model="form.specname"
        label="专业名称"
        disabled
        name="specname"
        :rules="formRules.specname"
      />
      <van-divider>教育经历(其他学历)非必填</van-divider>
      <van-field
        v-model="form.firstEducationLabel"
        label="其他学历"
        is-link
        readonly
        name="firstEducation"
        @click="showFirstEducationList = true"
      />
      <van-popup v-model:show="showFirstEducationList" position="bottom" teleport="body">
        <van-picker
          :columns="educationList"
          :columns-field-names="{ text: 'DTEXT', value: 'DVALUE' }"
          @confirm="onFirstEducationConfirm"
          @cancel="showFirstEducationList = false"
        />
      </van-popup>
      <van-field v-model="form.firstEducschool" label="毕业院校" name="firstEducschool" maxlength="15" />
      <van-field label="学习方式" name="firstEductype">
        <template #input>
          <van-radio-group
            v-model="form.firstEductype"
            direction="horizontal"
            checked-color="#da0b66"
            icon-size="16"
          >
            <van-radio name="1">统招</van-radio>
            <van-radio name="0">自考</van-radio>
            <van-radio name="2">函授</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-model="form.firstEducstart"
        label="开始时间"
        is-link
        readonly
        name="firstEducstart"
        @click="showFirstEducStart = true"
      />
      <van-popup v-model:show="showFirstEducStart" position="bottom" teleport="body">
        <van-datetime-picker
          type="year-month"
          :min-date="new Date(1990, 1, 1)"
          @confirm="onFirstEducStartConfirm"
          @cancel="showFirstEducStart = false"
        />
      </van-popup>
      <van-field
        v-model="form.firstEducend"
        label="结束时间"
        is-link
        readonly
        name="firstEducend"
        @click="showFirstEducEnd = true"
      />
      <van-popup v-model:show="showFirstEducEnd" position="bottom" teleport="body">
        <van-datetime-picker
          type="year-month"
          :min-date="new Date(1990, 1, 1)"
          @confirm="onFirstEducEndConfirm"
          @cancel="showFirstEducEnd = false"
        />
      </van-popup>
      <van-field
        v-model="form.firstSpectypeLabel"
        label="专业分类"
        is-link
        readonly
        name="firstSpectype"
        @click="showFirstSpecTypeList = true"
      />
      <van-popup v-model:show="showFirstSpecTypeList" position="bottom" teleport="body">
        <van-picker
          :columns="specTypeList"
          :columns-field-names="{ text: 'DTEXT', value: 'DVALUE' }"
          @confirm="onFirstSpecTypeConfirm"
          @cancel="showFirstSpecTypeList = false"
        />
      </van-popup>
      <van-field v-model="form.firstSpecname" label="专业名称" name="firstSpecname" maxlength="10" />
      <van-field label="曾任学生干部" name="isScadre" :rules="formRules.isScadre" disabled>
        <template #input>
          <van-radio-group v-model="form.isScadre" direction="horizontal" checked-color="#da0b66" icon-size="16" disabled>
            <van-radio name="1">是</van-radio>
            <van-radio name="0">否</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-show="form.isScadre === '1'"
        v-model="form.scadrePost"
        label="学生干部职位"
        placeholder="如：班长、团支书"
        name="scadrePost"
        maxlength="10"
        :rules="form.isScadre === '1' ? formRules.scadrePost : []"
      />
    </van-form>
  </div>
</template>
<script>
import { dateFormat, monthFormat } from '@/comm/comm.js'
import formRules from '@/comm/rules.js'
import { getDictData, changeDepart, changePost } from '@/api/api.js'
export default {
  name: 'EditBaseResume',
  props: {
    'resumeData': {
      type: Object
    }
  },
  setup() {
    const sfidFormatter = (value) => value.toUpperCase()
    return {
      sfidFormatter,
      formRules
    }
  },
  data() {
    return {
      showSfidDate: false,
      showNationList: false,
      showRecruitSourceList: false,
      showEducationList: false,
      showEducStart: false,
      showEducEnd: false,
      showSpecTypeList: false,
      showPostList: false,
      showReghouseList: false,
      showOrganList: false,
      showDepartList: false,
      postList: false,
      organList: [],
      departList: [],
      form: {},
      areaList: {
        province_list: {},
        city_list: {},
        county_list: {}
      },
      showFirstEducationList: false,
      showFirstEducStart: false,
      showFirstEducEnd: false,
      showFirstSpecTypeList: false,
      educationList: [],
      specTypeList: [],
      recruitSourceList: []
    }
  },
  watch: {
    resumeData: {
      handler(val) {
        this.form.post = val.POST
        this.form.postLabel = val.POSTLABEL
        this.form.organ = val.ORGAG
        this.form.organLabel = val.ORGANLABEL
        this.form.depart = val.depart
        this.form.departLabel = val.DEPARTLABEL
        this.form.name = val.NAME
        this.form.gender = val.GENDER
        this.form.sfid = val.SFID
        this.form.sfiddate = val.SFIDEDATE
        this.form.sfidaddr = val.SFIDADDR
        this.form.married = val.MARRIED
        this.form.political = val.POLITICAL
        this.form.politicalLabel = val.POLITICALLABEL
        this.form.nation = val.NATION
        this.form.nationLabel = val.NATIONLABEL
        this.form.recruitSource = val.RECRUITSOURCE
        this.form.recruitSourceLabel = val.RECRUITSOURCELABEL
        this.form.reghouse = val.REGHOUSE
        this.form.reghouseLabel = val.REGHOUSELABEL
        this.form.homeaddr = val.HOMEADDR
        this.form.workstatus = val.WORKSTATUS
        this.form.phone = val.PHONE
        this.form.interest = val.INTEREST
        this.form.education = val.EDUCATION
        this.form.educationLabel = val.EDUCATIONLABEL
        this.form.eductype = val.EDUCTYPE
        this.form.eductypeLabel = val.EDUCTYPELABEL
        this.form.educstart = val.EDUCSTART
        this.form.educend = val.EDUCEND
        this.form.spectype = val.EDUC_SPECTYPE
        this.form.spectypeLabel = val.SPECTYPE
        this.form.specname = val.SPECNAME
        this.form.educschool = val.EDUCSCHOOL
        this.form.firstEducation = val.FIRSTEDUCATION
        this.form.firstEducationLabel = val.FIRSTEDUCATIONLABEL
        this.form.firstEductype = val.FIRSTEDUCTYPE
        this.form.firstTypeLabel = val.FIRSTEDUCTYPELABEL
        this.form.firstEducstart = val.FIRSTEDUCSTART
        this.form.firstEducend = val.FIRSTEDUCEND
        this.form.firstSpectype = val.FIRSTEDUC_SPECTYPE
        this.form.firstSpectypeLabel = val.FIRSTSPECTYPE
        this.form.firstEducschool = val.FIRSTEDUCSCHOOL
        this.form.firstSpecname = val.FIRSTSPECNAME
        this.form.guid = val.GUID
        this.form.serial = val.SERIAL
        this.form.openid = val.OPENID
        this.form.email = val.EMAIL
        this.form.height = val.HEIGHT
        this.form.weight = val.WEIGHT
        this.form.isScadre = val.ISSCADRE
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.getDictData()
  },
  methods: {
    async getDictData() {
      await getDictData().then((response) => {
        const res = response.data
        if (res.code === 200) {
          this.nationList = res.data.nation
          this.educationList = res.data.education
          this.specTypeList = res.data.spectype
          this.postList = res.data.post
          this.organList = res.data.organ
          this.departList = res.data.depart
          this.areaList.province_list = res.data.sheng
          this.areaList.city_list = res.data.shi
          this.areaList.county_list = res.data.qu
          this.recruitSourceList = res.data.recruitSource
        }
      })
    },
    onNationConfirm(res) {
      this.showNationList = false
      this.form.nationLabel = res.DTEXT
      this.form.nation = res.DVALUE
    },
    onRecruitSourceConfirm(res) {
      this.showRecruitSourceList = false
      this.form.recruitSourceLabel = res.DTEXT
      this.form.recruitSource = res.DVALUE
    },
    onEducationConfirm(res) {
      this.showEducationList = false
      this.form.educationLabel = res.DTEXT
      this.form.education = res.DVALUE
    },
    onSfidDateConfirm(res) {
      this.showSfidDate = false
      this.form.sfiddate = dateFormat(res)
    },
    onEducStartConfirm(res) {
      this.showEducStart = false
      this.form.educstart = monthFormat(res)
    },
    onEducEndConfirm(res) {
      this.showEducEnd = false
      this.form.educend = monthFormat(res)
    },
    onSpecTypeConfirm(res) {
      this.showSpecTypeList = false
      this.form.spectypeLabel = res.DTEXT
      this.form.spectype = res.DVALUE
    },
    onPostListConfirm(res) {
      this.showPostList = false
      this.form.postLabel = res.PNAME
      this.form.post = res.ID
    },
    onOrganListConfirm(res) {
      this.showOrganList = false
      this.form.organLabel = res.LNAME
      this.form.organ = res.ID
      changeDepart({ organ: res.ID }).then((response) => {
        const res = response.data
        if (res.code === 200) {
          this.departList = []
          this.departList = res.data
          this.form.depart = ''
          this.form.departLabel = ''
          this.form.post = ''
          this.form.postLabel = ''
        }
      })
    },
    onDepartListConfirm(res) {
      this.showDepartList = false
      this.form.departLabel = res.LNAME
      this.form.depart = res.ID
      changePost({ depart: res.ID }).then((response) => {
        const res = response.data
        if (res.code === 200) {
          this.postList = []
          this.postList = res.data
          this.form.post = ''
          this.form.postLabel = ''
        }
      })
    },
    onReghouseConfirm(res) {
      this.showReghouseList = false
      this.form.reghouseLabel = res
        .filter((item) => !!item)
        .map((item) => item.name)
        .join('/')
      this.form.reghouse = res[2]['code']
    },
    onFirstEducStartConfirm(res) {
      this.showFirstEducStart = false
      this.form.firstEducstart = monthFormat(res)
    },
    onFirstEducEndConfirm(res) {
      this.showFirstEducEnd = false
      this.form.firstEducend = monthFormat(res)
    },
    onFirstSpecTypeConfirm(res) {
      this.showFirstSpecTypeList = false
      this.form.firstSpectypeLabel = res.DTEXT
      this.form.firstSpectype = res.DVALUE
    },
    onFirstEducationConfirm(res) {
      this.showFirstEducationList = false
      this.form.firstEducationLabel = res.DTEXT
      this.form.firstEducation = res.DVALUE
    },
    onReset() {
      this.$refs.form.resetValidation()
    },
    validateForm() {
      return this.$refs.form.validate()
    }
  }
}
</script>
<style scoped>
::v-deep .van-dialog {
  top: 50% !important;
  overflow: scroll !important;
}
</style>
